import React, { useState } from 'react';
import 'twin.macro';
import { Color } from '@teetsh/app/src/types/colors';
import { TabsWithUnderline } from '@teetsh/app/src/components/Tabs/TabsWithUnderline';
import { ColorPalette, ColorsList, Option } from './ColorsList';
import { useTranslation } from 'react-i18next';
import { ColorPaletteConfig } from 'containers/App/context/useColorPalette';

type CommonProps = {
  value: string;
  onChange: (v: Color) => void;
  className?: string;
};

type PropsWithColorPalette = CommonProps & {
  colorPalette: ColorPaletteConfig;
  options?: never; // Ensure options is not provided when colorPalette is
};

type PropsWithOptions = CommonProps & {
  colorPalette?: never; // Ensure colorPalette is not provided when options is
  options: Option[];
};

type Props = PropsWithColorPalette | PropsWithOptions;

export function ColorsListDualPalette(props: Props) {
  const { value, onChange, className } = props;
  const [selectedPalette, setSelectedPalette] = useState<ColorPalette>(
    props.colorPalette === 'old' ? 'old' : 'new',
  );
  const { t } = useTranslation(['common']);

  return (
    <div className={className}>
      {props.colorPalette && props.colorPalette === 'both' && (
        <TabsWithUnderline<ColorPalette>
          onChange={setSelectedPalette}
          tabs={[
            {
              label: t('colors.newPalette'),
              id: 'new',
              current: selectedPalette === 'new',
            },
            {
              label: t('colors.oldPalette'),
              id: 'old',
              current: selectedPalette === 'old',
            },
          ]}
          display="grid"
          noSelect
        />
      )}
      <div tw="max-h-64 mt-4 -mx-2 px-2 overflow-y-auto">
        {props.options ? (
          <ColorsList
            onChange={onChange}
            value={value}
            options={props.options}
          />
        ) : (
          <ColorsList
            onChange={onChange}
            value={value}
            colorPalette={selectedPalette}
          />
        )}
      </div>
    </div>
  );
}
